export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Informacje rejestracyjne"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potwierdzono"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Publicznie dostępne"])}
}